import {
    EDIT_EMPLOEE_ON_HOLD_REQUEST,
    EDIT_EMPLOEE_ON_HOLD_SUCCESS,
    EDIT_EMPLOEE_ON_HOLD_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const editEmployeeOnHoldReducer = (state = initialState, action) => {
    switch (action.type) {
        case EDIT_EMPLOEE_ON_HOLD_REQUEST:
            return {
                error: "",
                loading: true,
                data: [],
            };

        case EDIT_EMPLOEE_ON_HOLD_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case EDIT_EMPLOEE_ON_HOLD_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
}

export default editEmployeeOnHoldReducer;
